/** Sprites as data (docs/spec/04 §1): one character per pixel, a small palette per sprite. */

export interface SpriteDef {
  /** Frames of rows of equal length. `.` is transparent; any other character is looked up in `colours`. */
  readonly frames: readonly (readonly string[])[];
  /** Character to palette index (render/palette.ts) or `#rrggbb`. */
  readonly colours: Readonly<Record<string, number | string>>;
  /** Pre-rotate to 24 headings. The art faces up. */
  readonly rotates?: boolean;
}

/** Headings a rotating sprite is drawn at: every 15 degrees. */
export const ROTATIONS = 24;

/** A sprite drawn as its left half: each row is mirrored to make the whole. */
export function mirror(half: readonly string[]): string[] {
  return half.map((row) => row + [...row].reverse().join(''));
}

/** The same frames with other colours (the captive, the struck Monarch). */
export function recolour(def: SpriteDef, colours: Readonly<Record<string, number | string>>): SpriteDef {
  return { ...def, colours: { ...def.colours, ...colours } };
}
